export const NAMESPACE = 'rest';
export const SUCCESS_MUTE = true;
export const DEFAULT_PORTAL = '/market/market';
export const DEFAULT_PORTAL_NAME = 'MarketMarket';
export const MAX_TAB_SIZE = 10;
export const PF_QUOTE_QUANTITY_SCALE = 12;
export const PF_QUOTE_FREQUENCY_SCALE = 1;
export const BR_QUOTE_FREQUENCY_SCALE = 1;
export const CO_SYMBOL_FREQUENCY_SCALE = 1;
